
import React, { Fragment, PureComponent, memo, useContext, useState, useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  fas,
  faGlobeAmericas,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
library.add(fas);
import {
  Accordion,
  Card,
  Button,
  Row,
  Col,
  Container,
  Dropdown,
} from "react-bootstrap";

import { ImagenesRutas, SiteRutas, UtilitariosRutas } from "../request/RutasConfig.jsx";

import { Notificacion } from "../components/Util/Notificacion/Notificacion.jsx";
import { GlobalParamCont } from '../App.js';
import { removejscssfile } from "../components/Util/Util.jsx";

 function HomePage() {
  const appVersion = document.getElementById("appVersion").value;
  let history = useHistory();
  const globalParamCont = useContext(GlobalParamCont);

  useEffect(()=>{
    console.log('Home page');
  })

  const prueba =()=>{
    // removejscssfile("MultiNestedList.js", "js") //remove all occurences of "somescript.js" on page
    // removejscssfile("perfect-scrollbar.js", "js") //remove all occurences of "somescript.js" on page

    // const scriptTree = document.createElement("script");
    // scriptTree.src =  UtilitariosRutas.perfectScrollbar; //baseUrl + "Public/lib/perfect-scrollbar/perfect-scrollbar.js";
    // scriptTree.async = false;
    // document.body.appendChild(scriptTree);



    // const script = document.createElement("script");
    // script.src =  UtilitariosRutas.MultiNestedList; //baseUrl + "Public/lib/utilitarios/MultiNestedList.js";
    // script.async = false;
    // document.body.appendChild(script);

    //const s = document.createElement("script");
    //s.type = "text/javascript";
    //s.async = false;
    //s.innerHTML = "new PerfectScrollbar('.side-bar');";
    //document.body.appendChild(s);
    history.push(SiteRutas.Empleados);
  }
  return (
    <Fragment>
    <div className="body-content">
      <div className="main-container">
        <div className="main-content">
          <div className="">
            <div className="container-fluid container-fullw bg-white">
              <div className="row text-center">
                <div className="col-md-3"></div>
                <button onClick={()=>{history.push(`${SiteRutas.CambiarContrasena}/0`)}}>Cambiar Contraseña </button>  
                <button onClick={prueba}>Empresa</button>
              </div>
              
              <div >
                <div className="col border text-center">
                  <div className="inicio">
                    <img src={ImagenesRutas.Logo_LD} />
                  </div>
                </div>
              </div>
              <div >
                <div className="col">
                  <div className="text-center">
                  
                    <p>
                      {" "}
                      Desarrollado por: Logical Data, CR. Versión:{" "}
                      {appVersion} | Todos los Derechos Reservados |
                      Contáctenos:{" "}
                      <FontAwesomeIcon icon={faGlobeAmericas} />{" "}
                      <a href="http://www.ld.co.cr/" title="">
                        {" "}
                        http://www.ld.co.cr/{" "}
                      </a>
                      | <FontAwesomeIcon icon={faEnvelope} />{" "}
                      <a href="mailto:info@ld.co.cr">info@ld.co.cr</a>&nbsp;|&nbsp;
                      <i className="clip-phone-4"></i> +(506) 4052-2780
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Fragment>
  );
};
export default withRouter(memo(HomePage))